// extracted by mini-css-extract-plugin
module.exports = {"account-menu__item_active":"Profile_account-menu__item_active__zUqdI"};